<template>
  <div class="my-4 tablet:my-8">
    <div class="mb-3 text-headline-xs">
      {{ $t(`form.select.headline.${name}`) }}
      <span>*</span>
    </div>

    <div class="flex flex-wrap gap-3">
      <label
        v-for="option in options"
        :key="option.slug"
        class="inline-flex cursor-pointer items-center justify-center border border-black font-semibold text-black transition-colors duration-100 hover:border-mint hover:bg-mint hover:text-white"
        :class="{
          'h-[28px] px-3 py-2 text-xs': options.length > 5,
          'h-[44px] px-4 py-3 text-sm': options.length <= 5,
          'border-mint bg-mint text-white': model?.includes(option.id),
        }"
      >
        <input v-model="selected" :value="option.id" type="checkbox" class="hidden" />
        {{ $t(`form.select.${name}.${option.slug}`) }}
      </label>
    </div>

    <ValidationError :validation="validation" />
  </div>
</template>

<script setup lang="ts">
import type { BaseValidation } from '@vuelidate/core'
import { computed } from 'vue'

import ValidationError from '@/components/CreateJob/ValidationError.vue'

type PossibleOption = {
  id: string
  slug: string
}

defineProps<{
  options: PossibleOption[]
  validation: BaseValidation
  name: string
}>()

const model = defineModel<string[]>()

const selected = computed({
  get() {
    return [...(model.value || [])]
  },
  set(newValue) {
    model.value = newValue
  },
})
</script>
